<template lang="pug">
div
  #preloader(v-if="gameLaunching")
    #loader
</template>
<script>
export default {
  data() {
    return {
      feedback: {
        success: true,
        status: ""
      },
      gameLaunching:false,
      userPlatform: null,
      mobileDevice: false
    };
  },
  computed: {
    accountID() {
      return this.$store.getters.accountID;
    },
    sessionToken() {
      return this.$store.getters.sessionToken;
    },
    getLanguage() {
      return this.$store.getters.language || "en"
    },
    matchedLocale(){
      switch(this.getLanguage){
        case "en":
          return "en"
        case "my":
          return "my"
        case "zh":
          return "zh-CN"
        default :
          return "en"
      }
    },
  },
  created() {
    this.getMobile()
    var q = this.$route.query;
    this.launchGame(q.game, q.p);
  },
  methods: {
    getMobile() {
      if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
        this.userPlatform = "mobile"
        this.mobileDevice = true
      }else{
        this.userPlatform = "web"
        this.mobileDevice = false
      }
    },
    launchGame(game, provider){
      if (this.sessionToken) {
        this.gameLaunching = true
				var vm = this
        let player_id = this.accountID
        let auth_token = this.sessionToken
        var game_code = game
        let is_mobile = this.mobileDevice
        var lang_code = this.getLanguage
        switch(provider){
          case "EPIC2":
            var path = "user/launchEpic2";
            lang_code = this.matchedLocale
            break;
          case "MEGAH5":
            var path = "user/launchMegaH5";
            break;
          case "LIVE22":
            var path = "user/launchLive22";
            break;
          case "JILI":
            var path = "user/launchJili";
            break;
          case "PP-S":
            var path = "user/launchPragmatic";
            break;
          case "JK":
            var path = "user/launchJoker";
            break;
          case "HBNR":
            var path = "user/launchHabanero";
            break;
          case "CQ9":
            var path = "user/launchCq9";
            break;
          case "FC":
          case "JDB":
          case "JDB-GTF":
          case "MG1":
          case "BG":
          case "YBNGO":
          case "RG":
          case "EVOP":
          case "PNG":
          case "EVONTT":
          case "EVORT":
          case "EVOBTG":
          case "EVONLC":
          case "BNG":
          case "AP":
          case "HSD":
          case "EVOLIVE":
          case "WIFY":
          case "YB":
          case "QM":
          case "ALG":
          case "SPB":
          case "GPKTBG":
          case "SSG":
          case "ALGM":
          case "LT":
          case "PP-C1":
          case "MG-C1":
          case "EZUGI":
          case "BB":
          case "GPK7MJ-C1":
          case "GPK7MJ":
          case "GPKBM":
          case "GPKSPINO":
            var path = "user/launchOneapi";
            break;
          case "SPADEG":
            var path = "user/launchSpadeGaming";
            game_code = ""
            break;
          case "MEGA888":
            var path = "user/launchMega888";
            game_code = ""
            break;
          case "KISSH5":
            var path = "user/launchKissh5";
            break;
          default:
            var path = ""
        }

        if(path == ""){
          this.gameLaunching = false
          this.$swal({
            title: vm.$tc("ui.attention"),
            confirmButtonText: "OK",
            text: vm.$t("message.list.launch_fail2"),
            type: "info"
          }).then(result => {
            window.close()
          });
          return;
        }

        this.$store
          .dispatch(path, { player_id, auth_token,game_code, lang_code, is_mobile, provider })
          .then(response => {
            if (response.success == true) {
							setTimeout(() => {
								window.location.assign(response.data)
                vm.gameLaunching = false
							}) 
            } else {        
              vm.gameLaunching = false     
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            vm.gameLaunching = false
            if((typeof response.status) != 'object'){
              if(response.status === 'free_credit_detected'){
                this.$swal({
                  title: vm.$tc("ui.attention"),
                  text: vm.$tc("message.list.free_credit_detected"),
                  showCancelButton: true,
                  type: "info",
                  confirmButtonText: vm.$tc("ui.ok"),
                  cancelButtonText: vm.$tc("ui.deposit"),
                }).then(result => {
                  if (result.value) {
                    window.close()
                  } else if (result.dismiss) {
                    if(result.dismiss === 'cancel'){
                      vm.$router.push("deposit").catch(error =>{})
                    }
                  }
                });
              }else{
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          });
      }else{
				this.$router.push('/login').catch(err => {})
			}
    }
  }
}
</script>